import HttpService from '../core'
export abstract class HttpSvcControl {
  constructor(public httpSvc: HttpService) {}
}
